<template>
  <BaseModal id="custom-images-modal" :value="true" @input="close">
    <div class="h-full w-full overflow-scroll">
      <div
        class="w-full text-center flex flex-col justify-center"
        v-for="imageSet in images"
        :key="imageSet.type"
      >
        <h3
          class="text-center text-green-700 text-2xl md:text-3xl w-full bg-gray-100 capitalize py-4"
        >
          {{ imageSet.type }}
        </h3>
        <div class="flex flex-row flex-wrap">
          <img
            v-for="image in imageSet.images"
            :key="image.id"
            :src="image.imageRoute"
            :alt="image.imageName"
            class="w-full max-w-xl"
          />
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { getCustomImagesApi } from "@/api/masterAdmin/ProductImagesService.js";
export default {
  name: "CustomImagesModal",
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      images: null
    };
  },
  mounted() {
    getCustomImagesApi(this.code)
      .then(res => {
        this.images = res;
      })
      .catch(() => {
        this.$toast.open({
          message: "Error loading images",
          type: "error",
          position: "top-right"
        });
        this.$emit("closed");
      });
  },
  methods: {
    close() {
      this.$emit("closed");
    }
  }
};
</script>
<style class="postcss">
#custom-images-modal {
  .modal-content {
    width: 70%;
    min-width: 350px;
    margin-top: 50px;
  }
}
</style>
